export default __webpack_public_path__ + "static/media/google.d7548f55.png";